import { render, staticRenderFns } from "./OrdersApprovalView.vue?vue&type=template&id=0c16312a"
import script from "./OrdersApprovalView.vue?vue&type=script&lang=js"
export * from "./OrdersApprovalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports